export const notStableTooltip = () => <>This video is being processed. Please wait until it is ready</>;
